// src/App.js

import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import { ThemeProvider } from './contexts/ThemeContext';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Terms from './components/Terms';
import Stats from './components/Stats';
import AboutPaulo from './components/AboutPaulo';
import AboutValues from './components/AboutValues.js';
import CookieConsent from './components/CookieConsent';
import './styles/overflow-fix.css';
import LogoCarousel from './components/LogoCarousel.js';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
function App() {
  
  useEffect(() => {
    if (!CSS.supports('scroll-behavior', 'smooth')) {
      const smoothScrollPolyfill = document.createElement('script');
      smoothScrollPolyfill.src =
        'https://polyfill.io/v3/polyfill.min.js?features=smoothscroll';
      document.head.appendChild(smoothScrollPolyfill);
    }

    let ticking = false;

    const handleScroll = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <ThemeProvider>
      <Router>
        <div className='App'>
          <Header />
          <div className='main-content'>
            <Routes>
              {/* Rota principal com todos os componentes da landing page */}
              <Route
                path='/'
                element={
                  <>
                    <main>
                      <Hero />
                      <Stats />
                      <About />
                      <AboutValues />
                      <AboutPaulo />
                      <Services />
                      <LogoCarousel />
                      <Contact />
                    </main>
                  </>
                }
              />
              {/* Nova rota para a página de Termos e Serviços */}
              <Route path='/terms' element={<Terms />} />
            </Routes>
            <Footer />
          </div>
          <CookieConsent />
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;
